import { UserRelevantApiModel } from "../models/express/express";
import { CommonModel } from "../models/shared/commone.model";
import { FileModel } from "../models/shared/file.model";
import { ProvinceModel, DistrictModel, SubdistrictModel } from "../models/users/user-profile.model";


export class ConferencingModel {

    administrativeCourt: number = null!;
    blackNumberCase: number = null!;
    blackNumberCaseSecId:number = null!
    suitBlackCode: number = 0;
    suitBlackYear: number = 0;
    filingAS: number = 0
    filingASDOCS: number = 1
    filingGroup: number = 0
    accusers: AccuserModel = new AccuserModel
    // plaintiffAndAttorneyNumbers: AccuseritemModel[] = []
    // defendantAndAttorneyNumbers: AccuseritemModel[] = []
    considerCase: ConsiderCaseModel = new ConsiderCaseModel

    conferencingLocation: number = null!
    conferencingLocationCourt: number = null!
    conferencingLocationDetail: ConferencingLocationDetail = new ConferencingLocationDetail
    suitID: number = 0;
    fdTID: number = 42;
    reQID: number = 0;


    trialId: number = null!

    day: number = null!
    mont: number = null!
    monthName: string = ''
    year: number = null!
    userSelected: number[] = []
    filesPermission: FileModel[] = []
    fileSuitPdf: FileModel[] = []
    fileSuitWord: FileModel[] = []
    filesEtc: FileModel[] = []
    pageCountPermissionPDf: number = 0
    pageCountSuitPDf: number = 0
    pageCountEtcPDf: number = 0
    suitTypeId:number = 0

}



export class UserDetailModel {
    prefixName: string = ''//แมพแล้ว
    firstName: string = ''//
    lastName: string = ''//
    address: string = ''//
    moo: string = '';//
    soi: string = '';//
    road: string = '';//
    provinceName: string = ''//
    districtName: string = ''//
    subDistrictName: string = ''//
    zipCode: string = ''//
    mobilePhone: string = ''//
    contactNumber: string = ''//
    contactNumberH: string = ''//
    fax: string = ''//
    email: string = ''//
    occupationName: string = ''//

    capital: number = 0
    fee: number = 0

    idCardNumber!: string;//
    BehindIdCardNumber!: string;
    birthDate: string = ''
    day: number = null!
    mont: number = null!
    monthName: string = ''
    year: number = null!
    age: number = null!
    phoneShow: string = ''
}



export class TempCreateConferencingModel {
    administrativeCourt: number = 0
    blackNumberCase: number = 0
    suitID: number = 0
    fdTID: number = 0
}
export class inputSearchModel {
    administrativeCourt: number = 0;
    blackNumberCase: number = 0;
    suitBlackCode: number = 0;
    suitBlackYear: number = 0;
    redNumberCase: number = 0;
    suitRedCode: number = 0;
    suitRedYear: number = 0;
    suitTypeId: number = 0
}

export class RefinputSearchModel {
    refCode: string = '';
    fdTID: number = 0;
}

export class RefinputResModel {

    caseId: number = 0;
}


export class AccuserModel {
    items: AccuseritemModel[] = []
}

export class AccuseritemModel {
    checked: boolean = false
    grouP_ID: number = 0
    grouP_NAME: string = ''
    acC_ID: number = 0
    seq: number = 0
}

export class UserAccuserModel {
    suiT_ACC_DATE!: Date
    suiT_BLACK_NO!: number
    suiT_BLACK_YEAR!: string
    courtName!: string
    secCode!: string
    items: UserAccuseritemModel[] = []
    suitAccused !: string
    suitAccuser !: string
}

export class UserAccuseritemModel {
    groupId: number = 0
    accName: string = ''
    accId: number = 0
}

export class ConsiderCaseModel {
    inTrial: boolean = false
    inQuiry: boolean = false
    inConcilation: boolean = false
    inJudgment: boolean = false
    inOthercase: boolean = false
    inOthercaseDetail: string = null!
}

export class ConferencingLocationDetail {
    address: string = null!
    road: string = null!
    province: string = null!;
    district: string = null!;
    subDistrict: string = null!;
    zipCode: string = null!
    reason: string = 'เพื่ออำนวยความสะดวกแก่คู่กรณี'

}







